import { App, Layout } from 'antd';
import React, { useState, useEffect, useContext } from 'react';
import { Application, resource, Bootstrap } from "@yulintu/freesia-bootstrap";
import Header from './Header';
import { Switch } from 'react-router-dom'
import Footer from './Footer';

export default function Immersive(props) {
    const { bgImage, style } = props;
    const context = useContext(Application.Context);
    const [manifests, setManifests] = useState([]);
    const header = props.metadata.props?.header;
    useEffect(() => {
        Bootstrap.resolve(props.metadata.children, props.metadata).then(data => {
            setManifests(data);
        }).finally(() => {
        });

    }, [props.metadata]);

    return <App className='wh100'>
        <Layout className='wh100'>
            <div className='wh100 layout-v' style={{
                background: `url(${resource(bgImage)})`,
                backgroundSize: `100% 100%`,
                ...style
            }}>
                <Layout.Header style={{
                    background: 'transparent',
                    ...header.style
                }}>
                    <Header title={props.metadata.props?.header?.title || props.metadata.alias}
                        {...props.metadata.props?.header}
                        metadata={props.metadata}
                    />
                </Layout.Header>
                <Layout.Content className='fill'>
                    <Switch>
                        {
                            Bootstrap.routes(context.factory, manifests, props.metadata, {
                                config: context.config,
                                // onLoginSuccess: onLoginSuccess
                            })
                        }
                    </Switch>
                </Layout.Content>
                <Layout.Footer style={{
                    background: 'transparent',
                    padding:"24px 0px 30px",
                    fontSize:"16px"
                }}>
                    <Footer {...props.footer} />
                </Layout.Footer>
            </div>
        </Layout>
    </App>
}